import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { Grid, Typography } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { PaginateAction } from 'src/core/redux/action/paginateAction'
import autobind from 'autobind-decorator'
import { CLOSED_SUBSCRIPTION, OPENED_SUBSCRIPTION, fetchPublicProductsCS, fetchPublicProductsOS, fetchMorePublicProductsOS, fetchMorePublicProductsCS } from 'src/core/redux/action/publicProductsAction'
import { PublicProductCriteria } from 'src/type/criteria/publicProductCriteria'
import PublicProductCard from './PublicProductCard'

const OSactions = new PaginateAction<any>(OPENED_SUBSCRIPTION, fetchPublicProductsOS)
const CSactions = new PaginateAction<any>(CLOSED_SUBSCRIPTION, fetchPublicProductsCS)

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
}

const MAPPING_FILTERS = {
    "NON_DEMARRE": "status",
    "SOUSCRIPTION_OUVERTE": "status",
    "EN_COURS_DE_VIE": "status",
    "REMBOURSE_PAR_ANTICIPATION": "status",
    "REMBOURSE_A_SON_TERME": "status",
    "PARTICIPATION": "profile",
    "RENDEMENT": "profile",
    "CAPITAL_GARANTI": "profile",
    "CAPITAL_PROTEGE": "profile",
    "AUTOCALL": "profile",
    "CLN": "profile",
    "PHOENIX": "profile",
    "PROTECTION": "profile",
    "REVERSE": "profile"
}

const FILTERS = {
    "opened-subsciption": [
        {label: "Souscription ouverte", value: "SOUSCRIPTION_OUVERTE"},
        {label: "Participation", value: "PARTICIPATION"},
        {label: "Rendement", value: "RENDEMENT"},
        {label: "Capital Garanti", value: "CAPITAL_GARANTI"},
        {label: "Capital Protégé", value: "CAPITAL_PROTEGE"},
        {label: "CLN", value: "CLN"},
        {label: "Phoenix", value: "PHOENIX"},
        {label: "Autocall", value: "AUTOCALL"},
    ],
    "closed-subsciption": [
        {label: "Non démarré", value: "NON_DEMARRE"},
        {label: "En cours de vie", value: "EN_COURS_DE_VIE"},
        {label: "Remboursé par anticipation", value: "REMBOURSE_PAR_ANTICIPATION"},
        {label: "Remboursé à son terme", value: "REMBOURSE_A_SON_TERME"},
        {label: "Participation", value: "PARTICIPATION"},
        {label: "Rendement", value: "RENDEMENT"},
        {label: "Capital Garanti", value: "CAPITAL_GARANTI"},
        {label: "Capital Protégé", value: "CAPITAL_PROTEGE"},
        {label: "CLN", value: "CLN"},
        {label: "Phoenix", value: "PHOENIX"},
        {label: "Autocall", value: "AUTOCALL"},
    ]
}

const FILTER_SELECTED_DEFAULT = {
    "opened-subsciption": ["SOUSCRIPTION_OUVERTE"],
    "closed-subsciption": ["EN_COURS_DE_VIE", "REMBOURSE_PAR_ANTICIPATION", "REMBOURSE_A_SON_TERME"]
}

const FILTER_ISOLATED = {
    "opened-subsciption": ["SOUSCRIPTION_OUVERTE"],
    "closed-subsciption": []
}


interface IState {
    filterOSSelected: string[]
    filterCSSelected: string[]
}

class PublicNews extends React.Component<IProps, IState> {
  componentDidMount(){
    const {promisesWithProgress, OSupdateObjectCriteria, CSupdateObjectCriteria} = this.props
    promisesWithProgress(
        CSupdateObjectCriteria({
            sort_by: 'created_at', order_by: 'desc', limit: 8,
            ...this.computeFilters(this.state.filterCSSelected)
        }),
        OSupdateObjectCriteria({
            sort_by: 'created_at', order_by: 'desc', limit: 8,
            ...this.computeFilters(this.state.filterOSSelected)
        }),
    )
  }

  state = {
    filterOSSelected: FILTER_SELECTED_DEFAULT["opened-subsciption"],
    filterCSSelected: FILTER_SELECTED_DEFAULT["closed-subsciption"]
  }

  render() {
    const {t, publicProductOS, publicProductCS, totalSizeOS, totalSizeCS} = this.props
    return (
        <>
            <section className="section__landing" style={{backgroundImage: "url('/assets/images/site/photo/box.jpg')"}}>
                <div className="section__content landing__text middle">
                    <h1 className="landing__title f-poppins">Découvrez notre catalogue produit</h1>
                </div>
            </section>

            <section className="bg-white fullWidth">
                <div className="section__content">
                        <h2 className="section__title f-poppins">Produits en offre au public ouverts à la souscription</h2>
                    <p className="text-bold">Filtrer par catégories</p>
                    <div className="fl-container fl-wrap mg-t-1r mg-b-1r">
                        {this.filtersRendering("opened-subsciption")}
                    </div>
                    <div>
                        {publicProductOS && 
                            <Grid container>
                                {publicProductOS.map(p => {
                                    return (
                                        <Grid item xs={12} md={3} key={`pp-os-grid-${p.id}`}>
                                            <PublicProductCard key={`pp-os-${p.id}`} entity={p}/>
                                        </Grid>
                                        )
                                    })
                                }
                                {publicProductOS.length < totalSizeOS &&
                                    <Grid item xs={12} style={{textAlign: "center"}}>
                                        <button
                                            className="btn-outline f-poppins"
                                            onClick={() => this.loadMorePublicProductOS(publicProductOS.length)}
                                        >{t.load_more}</button>
                                    </Grid>
                                }
                            </Grid>
                        }
                        {!publicProductOS &&
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body2" align="center">Pas de produit dispo</Typography>
                                </Grid>
                            </Grid>
                        }
                    </div>
                </div>
            </section>
            <br/>
            <br/>
            <section className="bg-white fullWidth">
                <div className="section__content">
                    <h2 className="section__title f-poppins">Produits en offre au public fermés à la souscription</h2>
                    <p className="text-bold f-poppins">Filtrer par catégories</p>
                    <div className="fl-container fl-wrap mg-t-1r mg-b-1r">
                        {this.filtersRendering("closed-subsciption")}
                    </div>
                    <div>
                        {publicProductCS && 
                            <Grid container>
                                {publicProductCS.map(p => {
                                    return (
                                        <Grid item xs={12} md={3} key={`pp-cs-grid-${p.id}`}>
                                            <PublicProductCard key={`pp-cs-${p.id}`} entity={p}/>
                                        </Grid>
                                        )
                                    })
                                }
                                {publicProductCS.length < totalSizeCS &&
                                    <Grid item xs={12} style={{textAlign: "center"}}>
                                        <button
                                            className="btn-outline f-poppins"
                                            onClick={() => this.loadMorePublicProductCS(publicProductCS.length)}
                                        >{t.load_more}</button>
                                    </Grid>
                                }
                            </Grid>
                        }
                        {!publicProductCS &&
                            <Grid container>
                                <Grid item xs={12}>
                                    <Typography variant="body2" align="center" className="f-poppins">Pas de produit dispo</Typography>
                                </Grid>
                            </Grid>
                        }
                    </div>
                </div>
            </section>
        </>
    )
  }

  @autobind
  private filtersRendering(publicProductType){
    const {filterOSSelected, filterCSSelected} = this.state
    const filterSelected = publicProductType === "opened-subsciption" ? filterOSSelected : filterCSSelected
    return FILTERS[publicProductType].map(f => (
        <div 
            className={`
                public__filter-tag 
                ${f.value}
                ${filterSelected.includes(f.value) ? "is-selected": ""}
                ${FILTER_ISOLATED[publicProductType].includes(f.value) ? "no-event": ""}
            `}
            onClick={() => this.handleFilter(f.value, publicProductType)}
        >
            {f.label}
        </div>
    ))
  }

  @autobind
  private handleFilter(filter, publicProductType){
    const {filterOSSelected, filterCSSelected} = this.state
    const {OSupdateObjectCriteria, CSupdateObjectCriteria} = this.props

    if(publicProductType === "opened-subsciption") {
        if(filterOSSelected.includes(filter)){
            const newfilterSelected = [...filterOSSelected.filter(x => x !== filter)]
            this.setState({filterOSSelected: newfilterSelected})
            OSupdateObjectCriteria(this.computeFilters(newfilterSelected))
          } else {
            const newfilterSelected = [...Array.from(new Set([...filterOSSelected, filter]))]
            this.setState({filterOSSelected: newfilterSelected})
            OSupdateObjectCriteria(this.computeFilters(newfilterSelected))
          }
    }

    if(publicProductType === "closed-subsciption") {
        if(filterCSSelected.includes(filter)){
            const newfilterSelected = [...filterCSSelected.filter(x => x !== filter)]
            this.setState({filterCSSelected: newfilterSelected})
            CSupdateObjectCriteria(this.computeFilters(newfilterSelected))
          } else {
            const newfilterSelected = [...Array.from(new Set([...filterCSSelected, filter]))]
            this.setState({filterCSSelected: newfilterSelected})
            CSupdateObjectCriteria(this.computeFilters(newfilterSelected))
          }
    }
  }

  @autobind
  private computeFilters(values: string[]){
    const filter = {} as PublicProductCriteria;
    const status = [];
    const profile = [];
    values.map(f => {
        if(MAPPING_FILTERS[f] === "status") {
            status.push(f)
        }
        if(MAPPING_FILTERS[f] === "profile") {
            profile.push(f)
        }
    })
    filter.status = status.join(",")
    filter.profile = profile.join(",")
    return filter
  }

  @autobind
  private loadMorePublicProductOS(length: number){
    const {OSloadMore, criteriaOS} = this.props
    OSloadMore({
        ...criteriaOS,
        offset: length
    })
  }

  @autobind
  private loadMorePublicProductCS(length: number){
    const {CSloadMore, criteriaCS} = this.props
    CSloadMore({
        ...criteriaCS,
        offset: length
    })
  }

}

const state2props = (state: RootState) => ({
    enterprise: state.accountInfo.enterpriseSelected,

    criteriaOS: state.paginate.openedSubscription.criteria,
    publicProductOS: state.paginate.openedSubscription.entities,
    isFetchingOS: state.paginate.openedSubscription.isFetching,
    totalSizeOS: state.paginate.openedSubscription.total_size,

    criteriaCS: state.paginate.closedSubscription.criteria,
    publicProductCS: state.paginate.closedSubscription.entities,
    isFetchingCS: state.paginate.closedSubscription.isFetching,
    totalSizeCS: state.paginate.closedSubscription.total_size
});

const dispatch2props = (dispatch: any) => ({
    OSupdateObjectCriteria: (obj: PublicProductCriteria) => dispatch(OSactions.updateCriteriaByObject(obj)),
    OSupdateCriteria: (name: string, value: any) => dispatch(OSactions.updateCriteria(name, value)),
    OSloadMore: (c: PublicProductCriteria) => dispatch(fetchMorePublicProductsOS(c)),
    OSsearch: (c: PublicProductCriteria) => dispatch(fetchPublicProductsOS(c)),

    CSupdateObjectCriteria: (obj: PublicProductCriteria) => dispatch(CSactions.updateCriteriaByObject(obj)),
    CSupdateCriteria: (name: string, value: any) => dispatch(CSactions.updateCriteria(name, value)),
    CSloadMore: (c: PublicProductCriteria) => dispatch(fetchMorePublicProductsCS(c)),
    CSsearch: (c: PublicProductCriteria) => dispatch(fetchPublicProductsCS(c))
});

export default compose(
    withI18n,
    withRouter,
    withGlobalProgress,
    withToast,
    connect(state2props, dispatch2props),
)(PublicNews)



// WEBPACK FOOTER //
// ./src/page/PublicProduct/PublicProduct.tsx